import { GridQuestion } from "./grid-question";
import type { QuestionTypeRendererProps } from "./shared";

type MultipleChoiceGridQuestionProps = QuestionTypeRendererProps<"multiple_choice_grid">;

export default function MultipleChoiceGridQuestionType(props: MultipleChoiceGridQuestionProps) {
  return <GridQuestion {...props} kind="multiple_choice_grid" />;
}
